import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { InsightInitialValues, InsightValidationSchema } from '../../constant';
import { AppContext } from '../../../../context/appContext';
import { useGetYearsHook } from '../../../../Hooks/useGeneralHook';
import { useMutateCreateInsight } from '../../hooks/useApiHook';
import { ErrorToast, SuccessToast } from '../../../../Utils/SweetAlert';
import { Switch } from '@mui/material';
import TextEditor from '../../../../Components/TextEditor';
import InputWithLabel from '../../../../Components/InputWithLabel';
import SelectBox from '../../../../Components/SelectBox';

const AddInsight = () => {
  const navigate = useNavigate();

  const { isYearLoading, years, isServicesLoading, services, isCountriesLoading, countries } = useContext(AppContext);
  const yearOption = useGetYearsHook(years?.data?.min_year, years?.data?.max_year);
  const addInsightApi = useMutateCreateInsight();

  const handleSubmitAddInsight = (values) => {
    const reqData = {
      title: values?.title,
      description: values?.description,
      year: values?.year?.value,
      country_id: values?.country_id?.value,
      type_id: values?.type_id?.value,
      is_paid: values?.is_paid,
      is_active: values?.is_active,
    };

    addInsightApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || 'Added successful.');
        navigate('/admin/insight');
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || 'Server error.');
      },
    });
  };
  return (
    <>
      <Helmet>
        <title>Parato | Admin Add Insight</title>
      </Helmet>
      <div className='page-wrapper'>
        <div className='content container-fluid'>
          <div className='page-header'>
            <div className='row'>
              <div className='col'>
                <h3 className='page-title'>Add Insight</h3>
                <ul className='breadcrumb'>
                  <li className='breadcrumb-item'>
                    <Link to='/admin/dashboard' className='text-info text-decoration-underline'>
                      Dashboard
                    </Link>
                  </li>
                  <li className='breadcrumb-item'>
                    <Link to='/admin/insight' className='text-info text-decoration-underline'>
                      Insights
                    </Link>
                  </li>
                  <li className='breadcrumb-item active'>Add Insight</li>
                </ul>
              </div>
              <div className='col-auto'>
                <Link to='/admin/insight' className='btn btn-them-gray me-1'>
                  <i className='fas fa-angle-double-left' /> Back
                </Link>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='card'>
                <div className='card-header'>
                  <h5 className='card-title'>Insight Details</h5>
                </div>
                <div className='card-body'>
                  <Formik
                    initialValues={InsightInitialValues}
                    validationSchema={InsightValidationSchema}
                    validateOnChange
                    onSubmit={handleSubmitAddInsight}
                  >
                    {(formik) => {
                      const { errors, touched, isSubmitting, setFieldValue } = formik;
                      return (
                        <Form>
                          <div className='row'>
                            <div className='col-md-6'>
                              <Field
                                Label='Title'
                                type='text'
                                name='title'
                                placeholder='Enter title'
                                component={InputWithLabel}
                              />
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label className='text-white'>
                                  Index <span className='text-danger'>*</span>
                                </label>
                                <Field
                                  name='type_id'
                                  placeholder='Select index'
                                  component={SelectBox}
                                  options={services}
                                  isLoading={isServicesLoading}
                                />
                                <ErrorMessage name='type_id' component='span' className='error' />
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label className='text-white'>
                                  Year <span className='text-danger'>*</span>
                                </label>
                                <Field
                                  name='year'
                                  placeholder='Select year'
                                  component={SelectBox}
                                  options={yearOption}
                                  isLoading={isYearLoading}
                                />
                                <ErrorMessage name='year' component='span' className='error' />
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <label className='text-white'>
                                  Country <span className='text-danger'>*</span>
                                </label>
                                <Field
                                  name='country_id'
                                  placeholder='Select country'
                                  component={SelectBox}
                                  options={countries}
                                  isLoading={isCountriesLoading}
                                />
                                <ErrorMessage name='country_id' component='span' className='error' />
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-md-12'>
                              <div className='form-group'>
                                <label className='text-white'>
                                  Description <span className='text-danger'>*</span>
                                </label>
                                <Field
                                  className={`form-control ${
                                    errors.description && touched.description ? 'input-error' : null
                                  }`}
                                  name='description'
                                  component={TextEditor}
                                />
                                <ErrorMessage name='description' component='span' className='error' />
                              </div>
                            </div>
                            <div className='row'>
                              <div className='form-group col-md-2'>
                                <label className='d-block text-white'>Is Paid</label>
                                <div>
                                  <Switch
                                    name='is_paid'
                                    onClick={(e) => {
                                      setFieldValue('is_paid', e.target.checked);
                                    }}
                                  />
                                </div>
                                <ErrorMessage name='is_paid' component='span' className='error d-block' />
                              </div>
                              <div className='form-group col-md-2'>
                                <label className='d-block text-white'>Is Active</label>
                                <div>
                                  <Switch
                                    name='is_active'
                                    onClick={(e) => {
                                      setFieldValue('is_active', e.target.checked);
                                    }}
                                  />
                                </div>
                                <ErrorMessage name='is_active' component='span' className='error d-block' />
                              </div>
                            </div>
                          </div>
                          <div className='text-end mt-4'>
                            <button type='submit' className='btn btn-them-gray btnstl' disabled={isSubmitting}>
                              Add Insight
                              {isSubmitting && <i className='fas fa-spinner fa-spin'></i>}
                            </button>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
            {/* <div className='container-fluid absolute mb-4'>
              <footer className='text-center text-lg-start'>
                <div className='text-center'>Pareto with Pareto Economics Ltd.</div>
              </footer>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddInsight;
